import React from 'react';
import styled from 'styled-components';
import { ArrowDownIcon, ArrowUpIcon } from '../../../assets/svg/SVGComponents';
import { tones } from '../../../styles/brand';

const Badge = styled.span<{ $up: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.05rem 0.35rem;
  border-radius: 999px;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.7rem;
  font-variant-numeric: tabular-nums;
  background: ${({ $up }) => ($up ? tones.green.soft : tones.red.soft)};
  color: ${({ $up }) => ($up ? tones.green.text : tones.red.text)};

  svg {
    width: 0.8rem;
    height: 0.8rem;
  }
`;

interface IMovementBadgeProps {
  /** Posições ganhas (positivo) ou perdidas (negativo). */
  delta: number;
}

/** Substitui os ▲/▼ de texto da classificação. */
const MovementBadge: React.FC<IMovementBadgeProps> = ({ delta }) => {
  if (!delta) return null;
  const up = delta > 0;
  const Icon = up ? ArrowUpIcon : ArrowDownIcon;
  return (
    <Badge
      $up={up}
      aria-label={`${up ? 'Subiu' : 'Caiu'} ${Math.abs(delta)} ${
        Math.abs(delta) === 1 ? 'posição' : 'posições'
      }`}
    >
      <Icon aria-hidden stroke="currentColor" strokeWidth={2.5} fill="none" />
      {Math.abs(delta)}
    </Badge>
  );
};

export default MovementBadge;
